import React, { useEffect } from 'react';
import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import FormContainer from '../../Models/FormContainer';
import ResetPassword from '../../Editors/ResetPassword';
import { Container } from 'reactstrap';
import {fetchJSON } from 'refresh-fetch';
import { useAlert } from '../../../Services/AlertContext';
import { useAuth } from '../../../Services/AuthContext';
import { login } from '../../../Services/Auth';
const RespondToInvite = ({ getUrl, acceptUrl, validation,editor }) => {
    const { id } = useParams();
    const [item, setItem] = useState();
    const history = useHistory();
    const alert = useAlert(); 
    const [user, setUser] = useAuth();
    useEffect(() => {
        try {
            
            fetchJSON(getUrl + id).then( (result) => {
                if (result.response.status === 200) {
                    const p = { password: '', checkPassword: '' };
                    if (result.body.id !== '00000000-0000-0000-0000-000000000000') {
                        setItem({ ...p, ...result.body })
                        if (user.email !== result.body.email) {
                            setUser({
                                type: 'removeAuthDetails'
                            });
                        }
                        else {
                            history.go("/Home");
                        }
                    }
                    else {
                       
                    }
                }
                else {
                    alert({
                        title: "Could not find anything matching your request.", body: <div>Hmmm...</div>
                    });
                }
            }, (error) => { console.log("Error", error) });
        }
        catch (e) {
            console.log(e);
        }
    }, [alert,getUrl,history,id,setUser,user.email]);
    const submitNewRequest = (values) => {
        try {
            return fetchJSON(acceptUrl, { method: 'POST', body: JSON.stringify(values) }).then((result) => {
                if (result.response.status === 200) {
                    var r = result.body;
                    var messages = r.messages.map((x) => <p>{x}</p>);

                    if (r.success) {
                        login(values.email, values.password, setUser).then(() => history.push("/home"));
                        
                        return true;
                    }
                    else {
                        alert({ title: "Error Registering", body: <div>{messages}</div> })
                        return false; 
                    }

                }
                else {
                    alert({ title: "Error", body: <div>{r.messages.map((x) => <p>{x}</p>)}</div> })
                         }
            }, (error) => alert({ title: "Error", body: JSON.stringify(error) }));
        }
        catch (e) {
            console.log(e);
        }
    };
    return item ? <Container>
        <FormContainer initialValues={item} validationSchema={validation} onSubmit={submitNewRequest} edit newRequest >
        <h1>Welcome To JetBidders</h1>
        {editor}
        <ResetPassword />
        </FormContainer>
    </Container> : null;
        }


         
export default RespondToInvite; 